import { render, staticRenderFns } from "./newDetailModel.vue?vue&type=template&id=e5ad051a&scoped=true&"
import script from "./newDetailModel.vue?vue&type=script&lang=js&"
export * from "./newDetailModel.vue?vue&type=script&lang=js&"
import style0 from "./newDetailModel.vue?vue&type=style&index=0&id=e5ad051a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ad051a",
  null
  
)

export default component.exports